const pathPrefix = '/api';

const handleResponse = async (response: Response) => {
  const data = await response.json();

  if (data && typeof data === 'object' && 'error' in data) {
    throw new Error(data.error);
  }

  if (!response.ok) {
    throw new Error(data?.message || `Request failed with status ${response.status}`);
  }

  return data;
};

const apiClient = {
  post: async (path: string, payload: object) => {
    const response = await fetch(`${pathPrefix}${path}`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    return handleResponse(response);
  },
  postFormData: async (path: string, payload: FormData) => {
    const response = await fetch(`${pathPrefix}${path}`, {
      method: 'POST',
      credentials: 'same-origin',
      body: payload as any,
    });
    return handleResponse(response);
  },
  get: async (path: string) => {
    const response = await fetch(`${pathPrefix}${path}`, {
      method: 'GET',
      credentials: 'same-origin',
    });
    return handleResponse(response);
  },
  patch: async (path: string, payload: object) => {
    const response = await fetch(`${pathPrefix}${path}`, {
      method: 'PATCH',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    return handleResponse(response);
  },
  put: async (path: string, payload: object) => {
    const response = await fetch(`${pathPrefix}${path}`, {
      method: 'PUT',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    return handleResponse(response);
  },
  putFormData: async (path: string, payload: FormData) => {
    const response = await fetch(`${pathPrefix}${path}`, {
      method: 'PUT',
      credentials: 'same-origin',
      body: payload,
    });
    return handleResponse(response);
  },
  delete: async (path: string) => {
    const response = await fetch(`${pathPrefix}${path}`, {
      method: 'DELETE',
      credentials: 'same-origin',
    });

    return response.status === 200 || response.status === 202 || response.status === 204;
  },
};

export default apiClient;
